module.exports = __webpack_public_path__ + "static/media/mozambique-flag-round-small.016d2238.jpg";